import angular, { ILogService, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { TiposDocStore } from 'src/_candidato/data/tiposStore'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import {
  ICuestionarioFormulario,
  IEstadoCvStore,
  IModelDocReq,
  IModelFormulario,
  IPregBusqueda,
  IPregsBusqueda,
  IReglaValidacionDoc,
  RestResponse,
} from 'src/model/candidato-api'

import { Dictionary, keyBy } from 'lodash'
import './panel-doc-requirements.scss'

class PanelDocRequirementsComponentCtrl {
  $loading = false
  $ready = false

  reglasVal: ReglaReqDoc[]
  estados: IEstadoCvStore
  tiposDoc: TiposDocStore
  pregsStore: PreguntasStore

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelDocRequirementsComponentCtrl] onInit')

    this._leerReglasVal()
  }

  private _leerReglasVal() {
    this.$loading = true

    this.AccesoDatos.Documentacion_CLIENT.reglasValidacionDocObligatoria().then((reglasResponse) => {
      this.estados = reglasResponse.estados
      this.tiposDoc = new TiposDocStore(reglasResponse.tiposdocs)
      this.pregsStore = new PreguntasStore(reglasResponse.forms, (idform) =>
        this.AccesoDatos.GestionCurr_CLIENT.pregsSeleccionCurriculumsFormulario(idform)
      )

      this.reglasVal = reglasResponse.reglasVal.map(
        (r) => new ReglaReqDoc(r, this.estados, this.tiposDoc, this.pregsStore)
      )

      this.$loading = false

      this.$timeout(() => (this.$ready = true), 100)
    })
  }

  nuevaReglaVal() {
    this.reglasVal.push(new ReglaReqDoc({} as IModelDocReq, this.estados, this.tiposDoc, this.pregsStore))
  }
}

angular.module('candidato').component('panelDocRequirements', {
  bindings: {
    // empresa: "<",
  },
  controller: PanelDocRequirementsComponentCtrl,
  // templateUrl: "panel-doc-requirements.component.html",
  template: require('./panel-doc-requirements.component.html'),
})

export class FormsStore {
  byId: Dictionary<IModelFormulario>

  constructor(public list: IModelFormulario[]) {
    this.byId = keyBy(list, (f) => f.idform)
  }
}

export class PregsFormulario {
  list: IPregBusqueda[]

  constructor(pregs: IPregsBusqueda<any>) {
    this.list = pregs.listPreguntas
  }
}

export class PreguntasStore {
  formsStore: FormsStore

  pregsPorFormulario: { [idform: number]: PregsFormulario } = {}

  constructor(
    list: IModelFormulario[],
    private pregsFormSupplier: (idform: number) => RestResponse<IPregsBusqueda<ICuestionarioFormulario>>
  ) {
    this.formsStore = new FormsStore(list)
  }

  async pregsParaFormulario(idform: number) {
    let _pregsForm = this.pregsPorFormulario[idform]

    if (!_pregsForm)
      // obtener las preguntas del formulario
      return (this.pregsPorFormulario[idform] = new PregsFormulario(await this.pregsFormSupplier(idform))).list
    else return _pregsForm.list
  }
}

export class ReglaReqDoc {
  $dirty = false

  rule: IModelDocReq

  constructor(
    rule: IModelDocReq,
    private estados: IEstadoCvStore,
    private tiposDoc: TiposDocStore,
    public pregsStore: PreguntasStore
  ) {
    this.actualiza({ regla: rule })
  }

  actualiza(_rule: IReglaValidacionDoc) {
    this.rule = _rule.regla

    this.$dirty = !this.rule.idreqdoc
  }

  get estadosList() {
    return this.estados.list
  }

  get tiposDocGruposList() {
    return this.tiposDoc.gruposDocList()
  }

  get formsList() {
    return this.pregsStore.formsStore.list
  }
}
